
import PropTypes from 'prop-types';
import React from 'react';
import Base from './Base';
import config from './config';

/**
 * Styled hr element
 */

const Divider = ({
  width,
  ...props
}) => {
  const { scale, borderColor } = config;

  return (
    <Base
      {...props}
      tagName="hr"
      className="Divider"
      baseStyle={{
        width,
        marginTop: scale[2],
        marginBottom: scale[2],
        border: 0,
        borderBottomWidth: 1,
        borderBottomStyle: 'solid',
        borderBottomColor: borderColor,
      }}
    />
  );
};

Divider.propTypes = {
  /** Sets a fixed width for stylistic options */
  width: PropTypes.number,
};

export default Divider;

